import { GameProviderReport } from '@core/models/game-provider-report.model';
import { EntityCollectionServiceBase, EntityCollectionServiceElementsFactory } from '@ngrx/data';
import { Injectable } from '@angular/core';

@Injectable()
export class GameProviderReportEntityService extends EntityCollectionServiceBase<GameProviderReport> {
  constructor(serviceElementsFactory: EntityCollectionServiceElementsFactory) {
      super('GameProviderReport', serviceElementsFactory);
  }
}